module.exports = __webpack_public_path__ + "img/index-slider-1.7acd0c41.svg";